import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import ConsumerMenu from 'components/consumer/consumer-menu';

// An instance of ConsumerMenu for the layout named NewLayout
const NewLayoutMenu = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ConsumerMenu config={{
      navlinks: [{
        title: "Warranty",
        link: "/our-guarantee"
      }, {
        title: "Shipping",
        link: "/shipping-and-delivery"
      }, {
        title: "Returns",
        link: "/returns"
      }, {
        title: "Pet and Kid-Friendly",
        link: "/pet-friendly"
      }, {
        title: "Materials",
        link: "/material-swatches"
      }, {
        title: "Product Care",
        link: "/product-care"
      }, {
        title: "Fit Guide",
        link: "/fit-guide"
      }, {
        title: "FAQs",
        link: "https://help.joybird.com"
      }, {
        title: "Financing",
        link: "/product-financing"
      }, {
        title: "Design Services",
        link: "/free-design-services"
      }]
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(NewLayoutMenu);